// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as NovaEmotion from "@cosmonexus/nova-emotion";

function Alert$Alert(props) {
  let __className = props.className;
  let title = props.title;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "info";
  let className = __className !== undefined ? __className : "";
  let palette = variant === "error" ? [
      NovaEmotion.theme.color.errorBg,
      Emotion.Utils.Color.error,
      NovaEmotion.theme.color.errorBorder
    ] : (
      variant === "warning" ? [
          NovaEmotion.theme.color.warningBg,
          Emotion.Utils.Color.warning,
          NovaEmotion.theme.color.warningBorder
        ] : (
          variant === "success" ? [
              NovaEmotion.theme.color.successBg,
              Emotion.Utils.Color.success,
              Emotion.Utils.Color.success
            ] : [
              NovaEmotion.theme.color.accentBg,
              Emotion.Utils.Color.info,
              Emotion.Utils.Color.primary
            ]
        )
    );
  let role = variant === "warning" || variant === "error" ? "alert" : "status";
  let alertClassName = Emotion.Css.cx([
    Emotion.Css.css({
      display: "flex",
      flexDirection: "column",
      gap: "0.25rem",
      padding: "0.875rem 1rem",
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      border: `1px solid ` + palette[2],
      backgroundColor: palette[0],
      color: palette[1],
      fontSize: "0.875rem",
      lineHeight: "1.5"
    }),
    className
  ]);
  return JsxRuntime.jsxs("div", {
    children: [
      title !== undefined ? JsxRuntime.jsx("strong", {
          children: title,
          className: Emotion.Css.css({
            fontWeight: "600",
            letterSpacing: "0.02em"
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: props.children
      })
    ],
    className: alertClassName,
    role: role
  });
}

let Alert = {
  make: Alert$Alert
};

export {
  Alert,
}
/* Emotion Not a pure module */
